<template>
  <div class="edit-contract">
    <div class="edit-contract-form">
      <my-form ref="formRef" :data="form" :loading="loading" :option="option" :page-key="pageKey"
        width="auto" :footer-visible="false" />
    </div>
    <!-- submit and reset -->
    <div v-if="pageKey != 'view'" class="edit-contract-nav edit-contract-footer p-2">

      <b-button type="submit" variant="primary" class="mr-3" :disabled="loading"
        @click.prevent="validationForm">
        {{ $t('_components.btns.save') }}
      </b-button>
      <b-button type="reset" variant="outline-secondary" :disabled="loading" @click="resetForm">
        {{ $t('_components.btns.cancel') }}
      </b-button>
    </div>
  </div>
</template>

<script>
import { BForm, BRow, BCol, BButton } from 'bootstrap-vue';
import interviewAPI from '@/api/staff/interview/index';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default {
  components: {
    BButton,
    MyForm: () => import('@/components/myForm/index.vue'),
  },
  props: {
    id: {
      type: String,
      default: undefined,
    },
    rowData: {
      type: Object,
      default: () => {},
    },
    pageKey: {
      type: String,
      default: 'edit',
    },
  },
  data() {
    return {
      form: {
        contractTemplate: '',
      },
      loading: false,
    };
  },
  computed: {
    option() {
      return {
        columns: [
          {
            label: 'Template of LOA',
            field: 'contractTemplate',

            type: 'select',
            dictBizCode: 'template_of_loa',
            formOption: {
              type: 'select',
              dictBizCode: 'template_of_loa',
              span: 4,
              rules: 'required',
            },
          },
          {
            label: this.i18n('name'),
            field: 'name',
            formOption: {
              span: 4,
              rules: 'required',
            },
          },
          {
            label: this.i18n('email'),
            field: 'email',
            formOption: {
              span: 4,
              rules: 'required',
            },
          },
          {
            label: this.i18n('mobile'),
            field: 'mobile',
            formOption: {
              span: 4,
              rules: 'required',
            },
          },
          {
            label: this.i18n('company'),
            field: 'company',
            formOption: {
              span: 4,
              type: 'select',
              dictCode: 'company',
              rules: 'required',
            },
          },
          {
            label: this.i18n('nric'),
            field: 'nric',
            formOption: {
              span: 4,
              rules: 'required',
            },
          },
          {
            label: 'Employee Code(Singapore)',
            field: 'singaporeNo',
            formOption: {
              span: 4,
            },
          },
          {
            label: 'Employee Code(China)',
            field: 'chinaNo',
            formOption: {
              span: 4,
            },
          },
          {
            label: this.i18n('entryDate'),
            field: 'entryDate',
            formOption: {
              span: 4,
              type: 'date',
              rules: 'required',
            },
          },
          {
            label: this.i18n('address1'),
            field: 'address1',
            formOption: {
              span: 4,
            },
          },
          {
            label: this.i18n('address2'),
            field: 'address2',
            formOption: {
              span: 4,
            },
          },

          // 不同Loa Template 展示的字段

          // loa_permanent
          {
            label: 'Commence Date(合约开始日期)',
            field: 'contractCommenceDate',

            formOption: {
              hide: !this.form.contractTemplate,
              span: 4,
              type: 'date',
              rules: 'required',
            },
          },

          // loa_contrac
          {
            label: 'Employment Duration (months)',
            field: 'employmentDuration',

            formOption: {
              hide:
                this.form.contractTemplate !== 'loa_contract' &&
                this.form.contractTemplate !== 'loa_internship' &&
                this.form.contractTemplate !== 'loa_remoteContract' &&
                this.form.contractTemplate !== 'loa_malaysiaContract',
              span: 4,
              type: 'number',
              rules: 'required',
            },
          },
          {
            label: 'Contract Date (合约结束日期) ',
            field: 'contractEndDate',

            formOption: {
              hide:
                this.form.contractTemplate !== 'loa_contract' &&
                this.form.contractTemplate !== 'loa_internship' &&
                this.form.contractTemplate !== 'loa_remoteContract' &&
                this.form.contractTemplate !== 'loa_malaysiaContract',
              span: 4,
              type: 'date',
              rules: 'required',
            },
          },
          {
            label: 'LOA Expire Date',
            field: 'contractExpireDate',

            formOption: {
              hide: this.form.contractTemplate !== 'loa_internship',
              span: 4,
              type: 'date',
              rules: 'required',
            },
          },
          {
            label: 'ID NO.',
            field: 'idNo',

            formOption: {
              hide:
                this.form.contractTemplate !== 'loa_remote' &&
                this.form.contractTemplate !== 'loa_remoteContract',
              span: 4,
              // type: 'number',
              rules: 'required',
            },
          },
          {
            label: 'Country of Reside In',
            field: 'residenceCountry',

            type: 'select',
            dictBizCode: 'nationality',
            formOption: {
              hide:
                this.form.contractTemplate !== 'loa_remote' &&
                this.form.contractTemplate !== 'loa_remoteContract',
              type: 'select',
              dictBizCode: 'nationality',
              span: 4,
              rules: 'required',
            },
          },

          {
            label: 'Job Scope',
            field: 'title',
            type: 'title',
            formOption: {
              span: 12,
              type: 'title',
            },
          },
          {
            label: this.i18n('jobName'),
            field: 'jobName',
            formOption: {
              span: 12,
            },
          },
          {
            label: 'Remuneration',
            field: 'title2',
            type: 'title',
            formOption: {
              span: 12,
              type: 'title',
            },
          },
          {
            label: this.i18n('basicSalary'),
            field: 'basicSalary',
            formOption: {
              span: 12,
            },
          },
          {
            label: this.i18n('allowance1'),
            field: 'allowance1',
            formOption: {
              span: 4,
            },
          },
          {
            label: this.i18n('allowance2'),
            field: 'allowance2',
            formOption: {
              span: 4,
            },
          },
          {
            label: this.i18n('allowance3'),
            field: 'allowance3',
            formOption: {
              span: 4,
            },
          },
          {
            label: this.i18n('deduction1'),
            field: 'deduction1',
            formOption: {
              span: 4,
            },
          },
          {
            label: this.i18n('deduction2'),
            field: 'deduction2',
            formOption: {
              span: 4,
            },
          },
          {
            label: this.i18n('deduction3'),
            field: 'deduction3',
            formOption: {
              span: 4,
            },
          },
          {
            label: 'Working Arrangement',
            field: 'title3',
            type: 'title',
            formOption: {
              span: 12,
              type: 'title',
            },
          },
          {
            label: this.i18n('category'),
            field: 'category',
            formOption: {
              span: 12,
              type: 'select',
              dictData: [
                {
                  label: 'I',
                  value: 'I',
                },
                {
                  label: 'II',
                  value: 'II',
                },
                {
                  label: 'III',
                  value: 'III',
                },
                {
                  label: 'IV',
                  value: 'IV',
                },
              ],
            },
          },
          {
            label: 'Leave',
            field: 'title4',
            type: 'title',
            formOption: {
              span: 12,
              type: 'title',
            },
          },
          {
            label: this.i18n('annualDays'),
            field: 'annualDays',
            formOption: {
              span: 12,
            },
          },
          {
            label: 'Probation',
            field: 'title5',
            type: 'title',
            formOption: {
              span: 12,
              type: 'title',
            },
          },
          {
            label: this.i18n('trial1'),
            field: 'trial1',
            formOption: {
              span: 6,
            },
          },
          {
            label: this.i18n('trial2'),
            field: 'trial2',
            formOption: {
              span: 6,
            },
          },
          {
            label: 'Term and Termination',
            field: 'title6',
            type: 'title',
            formOption: {
              span: 12,
              type: 'title',
            },
          },
          {
            label: this.i18n('notice'),
            field: 'notice',
            formOption: {
              span: 12,
            },
          },
        ],
      };
    },
  },
  mounted() {
    console.log(this.id, 'this.id');
    interviewAPI.contractDetail({ interviewId: this.id }).then((r) => {
      this.form = r.data.data;
      if (
        this.form.employmentDuration === -1 ||
        this.form.employmentDuration === '-1'
      ) {
        this.form.employmentDuration = null;
      }
      if (this.form.trial1 === -1) {
        this.form.trial1 = 0;
      }
      // this.form.contractTemplate = this.form.contractTemplate
    });
  },
  methods: {
    i18n(param) {
      return this.$t(`_staff.labelInterviewContract.${param}`);
    },
    resetForm() {
      this.form = {};
    },
    async validationForm() {
      const e = await this.$refs.formRef.validationForm();
      if (e) {
        if (this.form.contractCommenceDate && this.form.contractEndDate) {
          if (this.form.contractCommenceDate > this.form.contractEndDate) {
            this.$message.error(
              'The Commence Date(合约开始日期) must earlier than the Contract Date (合约结束日期)'
            );
            this.loading = false;
            return;
          }
        }
        this.loading = true;
        const params = this.form;
        params.contractCommenceDate = moment(
          params.contractCommenceDate
        ).format('YYYY-MM-DD');
        params.contractEndDate = moment(params.contractEndDate).format(
          'YYYY-MM-DD'
        );
        params.contractExpireDate = moment(params.contractExpireDate).format(
          'YYYY-MM-DD'
        );
        params.interviewId = this.id;
        params.processId = this.processId;
        // params['image_af_image'] =
        //   'https://qaqc.mcc.sg:9000/mcchr/upload/20240708/e45dc42fbf9f3d1bb055205783f7fc58.jpg';
        // params['image'] =
        //   'https://qaqc.mcc.sg:9000/mcchr/upload/20240708/e45dc42fbf9f3d1bb055205783f7fc58.jpg';
        interviewAPI.editContract(params).then(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('_default.toast.title'),
              icon: 'BellIcon',
              text: this.$t('_default.toast.text.success'),
              variant: 'success',
            },
          });
          this.$emit('close');
          this.loading = false;
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-contract {
  height: 100%;
  position: relative;
  &-form {
    height: calc(100% - 60px);
    overflow: hidden;
  }
  &-nav {
    font-size: 20px;
    font-weight: 400;
    color: #13419d;
    line-height: 28px;
    overflow-x: hidden;
  }
  &-body {
    box-sizing: border-box;
  }
  &-footer {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
<style lang="scss">
.edit-contract {
  &-form {
    .my-form {
      height: 98%;
    }
  }
}
</style>
